import { render, staticRenderFns } from "./CatalogosEdit.vue?vue&type=template&id=5ac9a671"
import script from "./CatalogosEdit.vue?vue&type=script&lang=js"
export * from "./CatalogosEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports